// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"eb010a08","660":"81109f86"}[chunkId] + ".chunk.js";
};